import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

const lineV = { hidden: { y: "105%" }, show: { y: "0%" } };

export const MaskLine = ({ children, delay = 0, className = "", animateNow = false }) => (
  <motion.span
    className={`block overflow-hidden pb-[0.08em] ${className}`}
    initial="hidden"
    {...(animateNow ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0 } })}
  >
    <motion.span className="block" variants={lineV} transition={{ duration: 1.1, delay, ease }}>
      {children}
    </motion.span>
  </motion.span>
);

export const Eyebrow = ({ children, className = "", line = true }) => (
  <div className={`flex items-center gap-4 font-sans text-[11px] tracking-[0.32em] uppercase ${className}`}>
    <span>{children}</span>
    {line && <span className="h-px w-12 bg-gold" />}
  </div>
);
